import {FormHelperText, TextField} from '@mui/material';
import {DatePicker, LocalizationProvider} from '@mui/x-date-pickers';
import React from 'react'
import {AdapterDayjs} from '@mui/x-date-pickers/AdapterDayjs';


const RFQDate = ({value, setRfqDate, error, disabled}) => {

    const handleChange = (newValue) => {
        const dateFromString = newValue;
        const dateFromData = new Date(dateFromString);
        const dayFrom = dateFromData.getDate().toString().padStart(2, '0');
        const monthFrom = (dateFromData.getMonth() + 1).toString().padStart(2, '0');
        const yearFrom = dateFromData.getFullYear();
        const convertedDateFrom = `${yearFrom}-${monthFrom}-${dayFrom}`;

        setRfqDate(convertedDateFrom);
    }

    return (
        <>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
                <DatePicker
                    inputFormat="DD/MM/YYYY"
                    value={value}
                    disabled={disabled}
                    onChange={handleChange}
                    renderInput={(params) => <TextField
                        {...params}
                        error={Boolean(error)}
                        InputProps={
                            disabled && {
                                style: {
                                    color: 'black !important',
                                    backgroundColor: 'hsl(0, 0%, 95%)',
                                },
                            }
                        }
                        label="RFQ Date" size="small" fullWidth/>}
                />
                {error && (
                    <FormHelperText sx={{color: '#d32f2f', ml: 0}}>{error.message || 'Required'}</FormHelperText>
                )}
            </LocalizationProvider>
        </>
    )
}

export default RFQDate
